import React from 'react';
import { TouchableOpacity, View } from 'react-native';

const TouchableInputFieldWrapper = props => {
  const { children, activeOpacity, wrapperProps, ...restProps } = props;

  return (
    <TouchableOpacity activeOpacity={activeOpacity || 1.0} {...restProps}>
      <View pointerEvents="none" {...wrapperProps}>
        {children}
      </View>
    </TouchableOpacity>
  );
};

TouchableInputFieldWrapper.defaultProps = {
  wrapperProps: {},
};

export default TouchableInputFieldWrapper;
